const binding = { modules: {}, dataActions: {} };

    (binding.modules['product-spotlight'] = {
        c: () => require('partner/modules/product-spotlight/product-spotlight.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-spotlight',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-spotlight'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|product-spotlight|product-spotlight'] = {
                c: () => require('partner/modules/product-spotlight/product-spotlight.view.tsx'),
                cn: '__local__-__local__-product-spotlight'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };